/**
 * PATH: packages/job-hub/src/jobs/qa/QaDragHandle.tsx
 * FILE_ID: JOBHUB-QA-DRAG-HANDLE-001
 * PURPOSE: The grip that replaces the up/down chevrons on a QA row.
 */
import { GripVertical } from 'lucide-react'
import { useIsMdUp } from '@quotech/ui'
import type { QaDropKind } from './qaDragCommit'
import { useQaDragHandlers } from './useQaPointerDrag'

export function QaDragHandle({
  kind,
  id,
  label,
  disabled = false,
}: {
  kind: QaDropKind
  id: string
  label: string
  disabled?: boolean
}) {
  const desktop = useIsMdUp()
  const drag = useQaDragHandlers()
  if (disabled) return null
  // Reused from: packages/quote-builder/src/components/builder/RowGutterCell.tsx (GripVertical; the grip does not start a row click).
  return (
    <span
      role="button"
      aria-label={`Drag ${label}`}
      data-testid={`qa-drag-${kind}-${id}`}
      title={`Drag ${label}`}
      className={desktop
        ? 'inline-flex h-6 w-6 shrink-0 cursor-grab items-center justify-center text-muted-foreground active:cursor-grabbing'
        : 'inline-flex h-11 w-11 shrink-0 touch-none cursor-grab items-center justify-center text-muted-foreground'}
      onPointerDown={(event) => {
        event.stopPropagation()
        event.preventDefault()
        drag?.onPointerDown(kind, id, event)
      }}
      onPointerMove={(event) => drag?.onPointerMove(event)}
      onPointerUp={(event) => drag?.onPointerUp(event)}
      onClick={(event) => event.stopPropagation()}
    >
      <GripVertical className={desktop ? 'h-3.5 w-3.5' : 'h-4 w-4'} aria-hidden />
    </span>
  )
}
